import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { KudoContentObjectDetailDataObject } from 'models/service';

export const getKudo = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.get<KudoContentObjectDetailDataObject, ApiClientResponse<KudoContentObjectDetailDataObject>>(
    routes.kudos.get(id),
  );
